import React, { useEffect, useState } from "react";
import { ActivityIndicator, Dimensions, Image, ScrollView, Text, TouchableOpacity, View } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/core";
import * as Clipboard from 'expo-clipboard';

import HeaderDefault from "../../components/HeaderDefault";

import { styles } from "./styles";

import InputDefault from "../../components/Form/InputDefault";
import NumberInput from "../../components/NumberInput";
import PaymentMethods from "../../components/PaymentMethods";
import Button from "../../components/Button";
import GradientButton from "../../components/GradientButton";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { formatCoin } from "../../utils/formatNumber";
import toast from "../../utils/toast";
import paymentService from "../../services/paymentService";
import formatDate from "../../utils/formatDate";
import QRCode from "react-native-qrcode-svg";
import { CardStyleInterpolators } from "@react-navigation/stack";

const DepositPix = () => {
  const navigation = useNavigation();

  const [value, setValue] = useState(0);
  const [pixCode, setPixCode] = useState('');
  const [expirationDate, setExpirationDate] = useState();

  useEffect(() => {
    async function createPixPayment() {
      const value = parseFloat(await AsyncStorage.getItem('depositAmount'));
      setValue(value);
      const token = await AsyncStorage.getItem('JWT_TOKEN');
      try {
        const response = await paymentService.createPix(token, value);
        const { pix_code, expiration_date } = response.data;
        console.log(response.data);
        setPixCode(pix_code);
        setExpirationDate(expiration_date);
      } catch (err) {
        console.log(err.response.data);
        if (err.response?.data?.message)
          toast(err.response.data.message, "#DA1414");
        else
          toast('Algo deu errado. Por favor, tente novamente mais tarde.', "#DA1414");
        navigation.navigate('Home');
      }
    }
    createPixPayment();
  }, []);

  const [copied, setCopied] = useState(false);
  function copyToClipboard() {
    Clipboard.setString(pixCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  const screenSize = Dimensions.get('screen');

  return (
    <View style={{ flex: 1 }}>
      <HeaderDefault title={"Depositar BRL"} />
      {
        !pixCode ? (
          <View style={styles.activityIndicatorContainer}>
            <ActivityIndicator color="#1FBFB5" size="large" style={styles.activityIndicator} />
          </View>
        ) : (
          <View style={styles.container}>
            <View>
              <View style={styles.headerInfo}>
                <View>
                  <Text style={styles.title}>PIX</Text>
                  <Text style={styles.value}>R$ {formatCoin(value)}</Text>
                </View>
                <View style={styles.dateContainer}>
                  <Text style={styles.bold}>Validade</Text>
                  <Text>{expirationDate && formatDate(expirationDate)}</Text>
                </View>
              </View>

              <Text style={styles.explanationText}>Copie o código Pix Copia e Cola ou escaneie o QR Code no seu app favorito.</Text>
              <Text style={styles.explanationText}><Text style={{fontWeight: 'bold'}}>Atenção:</Text> O pix pode demorar até 2 minutos para ser reconhecido. Assim que estiver liberado, o saldo será creditado na sua conta.</Text>

              <View style={styles.qrCodeContainer}>
                <QRCode value={pixCode} size={screenSize.width * 0.3} />
              </View>

              <View style={styles.codeContainer}>
                <View style={styles.codeHeader}>
                  <Text style={styles.bold}>Código</Text>
                  <TouchableOpacity onPress={copyToClipboard}>
                    <Text style={styles.copyText}>
                      {copied ? 'Copiado!' : 'Copiar'}
                    </Text>
                  </TouchableOpacity>
                </View>
                <Text>{pixCode}</Text>
              </View>
            </View>
            <GradientButton onPress={() => navigation.navigate('Home')}>Finalizar</GradientButton>
          </View>
        )
      }
    </View>
  );
};

export default DepositPix;
